import gql from "../gql";
export default gql `
  query LocationSuggestions($text: String!) {
    locationSuggestions(text: $text) {
      id
      suggestion
    }
  }
`;
